<script>
import {defineComponent} from 'vue';

export default defineComponent ({
    name: 'Dialog',

    // Expose functions to the parent component
    expose: ['openDialog', 'closeDialog'],

    emits: ['close', 'confirm'],

    components: {},

    props: {
        title: {
            type: String,
            default: 'Confirm',
            required: false,
        },
        message: {
            type: [String, Number],
            required: false,
            default: '',
        },
        color: {
            type: String,
            default: '#d6e9c6',
            required: false,
        },
        timeout: {
            type: Number,
            required: false,
            default: 1000
        },
    },

    data() {
        return {}
    },

    methods: {
        // Function to open the modal dialog
        openDialog() {
            if (this.$refs['dialog']) {
                // showModal() displays the dialog and a backdrop
                this.$refs['dialog'].showModal();
            }
        },

        // Function to close the dialog and emit a custom event
        closeDialog() {
            if (this.$refs['dialog']) {
                this.$refs['dialog'].close();
                // emit('close');
            }
        },
    },
});
</script>

<template>
    <teleport to="body">
        <dialog ref="dialog" class="dialog-box">
            <header class="dialog-header">
                <div class="left"><h4>{{ title }}</h4></div>
                <div class="right"><a title="Close" class="close" @click="closeDialog">X</a></div>
            </header>
            <div class="dialog-content">
                <slot>Please confirm.</slot>
            </div>
            <footer class="dialog-footer">
                <slot name="footer-buttons" :closeDialog="closeDialog">
                    <button @click="closeDialog">OK</button>
                </slot>
            </footer>
        </dialog>
    </teleport>
</template>

<style scoped>
.dialog-box {
  border: none;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  width: 50%;
  max-width: 80%;
}

.dialog-box::backdrop {
  background-color: rgba(0, 0, 0, 0.5);
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  /* padding-bottom: 10px; */
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.dialog-content {
  padding: 20px 0;
}

.dialog-footer {
  border-top: 1px solid #eee;
  padding-top: 10px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
